import { ref, Ref } from 'vue';
import { TStringPromiseResolve } from '@/models/promise-units.interface';
import PromiseHelper from '@/services/promise-helper';
import store from '@/store';

export default class UploadFileCode {
	public uploadButton: Ref<HTMLInputElement | null> = ref(null);
	private fileReader = new FileReader();

	public async processUpload(event: Event): Promise<void> {
		event.preventDefault();

		const file = this.retrieveUploadedFile();
		if (!file) {
			store.mutations.selectFileUpload(null);
			return;
		}

		await this.setUpload(file);
	}

	private retrieveUploadedFile(): File | undefined {
		if (!this.uploadButton.value) {
			return;
		}

		const files = this.uploadButton.value.files;
		if (!files || !files.length) {
			return;
		}

		return files[0];
	}

	private async setUpload(file: File): Promise<void> {
		const title = file.name;
		const contents = await this.retrieveRecordsFromFile(file);

		store.mutations.selectFileUpload(
			contents ? { title, contents } : null
		);
	}

	private async retrieveRecordsFromFile(file: File): Promise<string> {
		const promiseData = PromiseHelper.createStringPromise();

		this.fileReader.readAsText(file);
		this.readFileReaderResponse(promiseData.resolve);

		return promiseData.promise;
	}

	private readFileReaderResponse(resolve: TStringPromiseResolve): void {
		this.fileReader.onload = (): void => {
			const content = this.fileReader.result;
			if (!content) {
				void resolve('');
				return;
			}

			void resolve(content as string);
		};
	}
}
